export const componentCriticalityKeys = {
  all: ["component-criticality"] as const,
  list: () => [...componentCriticalityKeys.all, "list"] as const,
};
